import {Trend} from 'platform/components';
import {Right, Text} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {ReactNode} from 'react';

import {always} from 'ramda';

import i18n from '@dms/i18n';

import {EMPTY_PLACEHOLDER, Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

const NO_CHANGE = 0;

interface SalesLeagueRankChangeProps extends RequiredTestIdProps {
  /** Movement in rank since the previous window, never movement in vehicles. */
  trend: number | Nullish;
}

/**
 * The wire tells "held its rank" (`0`) and "held no rank last period" (`null`) apart, so the
 * column does too: the first reads "no change", the second a dash. Collapsing both into a
 * dash is what made the old single Trend column unreadable. See CONTEXT.md.
 */
export function SalesLeagueRankChange(props: SalesLeagueRankChangeProps) {
  const renderLabel = (label: string) => (
    <Text size="small" color="tertiary" noWrap data-testid={suffixTestId('rankChange', props)}>
      {label}
    </Text>
  );

  return (
    <Right>
      {match<number | Nullish, ReactNode>(props.trend)
        .with(Pattern.nullish, always(renderLabel(EMPTY_PLACEHOLDER)))
        .with(NO_CHANGE, always(renderLabel(i18n.t('page.salesLeague.table.rankNoChange'))))
        .otherwise((trend) => (
          <Trend
            label={Math.abs(trend).toString()}
            isPositive={trend > NO_CHANGE}
            isNegative={trend < NO_CHANGE}
            isTransparent
            data-testid={suffixTestId('rankChange', props)}
          />
        ))}
    </Right>
  );
}
